// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyCDbQMujr-ggUeK26IZW7Gvl7SqfYtTiXI",
//   authDomain: "smelectornic-2d61f.firebaseapp.com",
//   projectId: "smelectornic-2d61f",
//   storageBucket: "smelectornic-2d61f.firebasestorage.app",
//   messagingSenderId: "297252589603",
//   appId: "1:297252589603:web:0776c25edf22ddb6e36196",
//   measurementId: "G-YDVYLE44TB"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);



import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your Firebase Config
const firebaseConfig = {
    apiKey: "AIzaSyCDbQMujr-ggUeK26IZW7Gvl7SqfYtTiXI",
    authDomain: "smelectornic-2d61f.firebaseapp.com",
    projectId: "smelectornic-2d61f",
    storageBucket: "smelectornic-2d61f.firebasestorage.app",
    messagingSenderId: "297252589603",
    appId: "1:297252589603:web:0776c25edf22ddb6e36196",
    measurementId: "G-YDVYLE44TB"
};

// Initialize Firebase App
const app = initializeApp(firebaseConfig);

// Initialize Firestore Database
const db = getFirestore(app);

export { db };
